import { Outlet } from 'react-router-dom';

import { SectionTabs } from '../../shared/ui/SectionTabs';
import { ROUTES } from '../../shared/config/routes';

/**
 * Раздел «Аккаунты». Шаблоны оформления стали его вкладкой, а не пунктом меню:
 * заходят туда редко, и всегда — от конкретного аккаунта.
 *
 * «Добавить аккаунт» — в топбаре самой вкладки «Аккаунты» (AccountsPage):
 * на «Шаблонах оформления» он не к месту, и списки после входа перечитывает
 * та же страница.
 */
export function AccountsLayout(): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <SectionTabs
        tabs={[
          { to: ROUTES.ACCOUNTS, label: 'Аккаунты', end: true },
          { to: `${ROUTES.ACCOUNTS}/templates`, label: 'Шаблоны оформления' },
        ]}
      />

      <Outlet />
    </div>
  );
}
